/**
 * Boot overlay driver.
 *
 * The overlay shell (markup + critical CSS) lives in index.html so it paints
 * before the 1.6 MB bundle has even parsed — the whole point is that the
 * player sees "loading" during the seconds of procedural world generation and
 * shader pre-warm that used to be a plain black screen.
 *
 * This module only *drives* it:
 *   - engine.init() reports per-subsystem progress (see src/core/engine.js),
 *     which maps to the first ~62% of the bar with a per-system status line.
 *   - prewarm() reports its own progress via its existing onProgress hook,
 *     which fills the remaining ~38% ("compiling shaders").
 *   - done() removes the overlay synchronously BEFORE engine.start() schedules
 *     the first frame, so no boot DOM ever leaks into a captured shot: the
 *     pixel-diff gate (tools/imagediff.mjs) sees the same frames as before.
 */

const INDETERMINATE_CLASS = 'boot-indet';

export class BootScreen {
  constructor() {
    this.root = document.getElementById('boot');
    this.fill = document.getElementById('boot-fill');
    this.pct = document.getElementById('boot-pct');
    this.status = document.getElementById('boot-status');
    this._done = false;
  }

  setStatus(text) {
    if (this.status) this.status.textContent = text;
  }

  /** @param {number} f fraction 0..1 — first determinate tick also ends the
   *   indeterminate sweep that covers the pre-init gap. */
  setProgress(f) {
    const c = Math.min(1, Math.max(0, f));
    if (this.fill) {
      this.fill.style.width = (c * 100).toFixed(1) + '%';
      this.root?.classList?.remove(INDETERMINATE_CLASS);
    }
    if (this.pct) this.pct.textContent = Math.round(c * 100) + '%';
  }

  /** Remove the overlay. Must run before the first frame is scheduled. */
  done() {
    if (this._done) return;
    this._done = true;
    this.setProgress(1);
    this.root?.remove();
    this.root = null;
  }
}
